import {
  PROFILE_LOADED,
  PROFILE_LOAD_ERROR
} from 'actions/profileActions';
import { LOGOUT } from 'actions/authActions';

const initialState = {};

export default function auth (state = initialState, action) {
  const { profileData } = action;
  switch (action.type) {
  case PROFILE_LOADED:
    return { ...profileData };
  case PROFILE_LOAD_ERROR:
    return {};
  case LOGOUT:
    return { ...initialState };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/profileReducer.js